module.exports = "/_next/static/images/64c82882dc4f390446a9026c0e2d8d3b-clips@desktop1024.jpg";